import { CREDIT_CARD_PAYMENT_PROCESSOR } from "shared/payment/constants";

export default function getPaymentToken(paymentTokensList) {
	if (!paymentTokensList) {
		return {};
	}

	return paymentTokensList.reduce((memo, paymentToken) => {
		// if this is invalid, keep goin
		if (!paymentToken.isValid) {
			return memo;
		}

		// use this one only if the existing fucker is not a card
		if (paymentToken.paymentProcessor === CREDIT_CARD_PAYMENT_PROCESSOR &&
			(!memo || memo.paymentProcessor !== CREDIT_CARD_PAYMENT_PROCESSOR)) {
			return paymentToken;
		}

		// if we have no card already, use this one
		if (!memo) {
			return paymentToken;
		}

		// otherwise use what we got
		return memo;
	}, null) || {};
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/pick-payment-token.js